//#region IMPORT
import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';
import M_EIC_NEWF from '../M_EIC_NEW/M_EIC_NEWF';
import M_EIS_NEWF from '../M_EIS_NEW/M_EIS_NEWF';
//#endregion

export default function M_Master_NEW({ activeTab, onTabChange }) {
  const { equipReceiptAlarm } = useSelector((state) => state.equipment);
  const showReceiptDot = equipReceiptAlarm === '수령하기';
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* 탭 헤더 */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={onTabChange}
          variant="fullWidth"
          sx={{
            '& .MuiTab-root': {
              fontSize: '14px',
              fontWeight: 'bold',
              color: '#9E9E9E',
            },
            '& .Mui-selected': {
              color: '#33ABD1 !important',
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#33ABD1',
            },
          }}
        >
          <Tab label="지급하기" />
          <Tab
            label={
              <Box
                component="span"
                sx={{
                  display: 'inline-block',
                  position: 'relative',
                  pr: 0.75,
                }}
              >
                수령하기
                {showReceiptDot && (
                  <Box
                    component="span"
                    sx={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      width: 5,
                      height: 5,
                      borderRadius: '50%',
                      bgcolor: '#F55858',
                    }}
                    aria-hidden
                  />
                )}
              </Box>
            }
          />
        </Tabs>
      </Box>

      {/* 탭 콘텐츠 */}
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {activeTab === 0 && <M_EIC_NEWF />}
        {activeTab === 1 && <M_EIS_NEWF />}
      </Box>
    </Box>
  );
}
